import { render } from "./SlipInput.vue?vue&type=template&id=6dc33bbf&scoped=true&ts=true"
import script from "./SlipInput.vue?vue&type=script&lang=ts"
export * from "./SlipInput.vue?vue&type=script&lang=ts"

import "./SlipInput.vue?vue&type=style&index=0&id=6dc33bbf&scoped=true&lang=css"

import exportComponent from "/frontside/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc33bbf"]])

export default __exports__